import { render, staticRenderFns } from "./MobShareholderChart.vue?vue&type=template&id=566f6e78&scoped=true"
import script from "./MobShareholderChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MobShareholderChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobShareholderChart.vue?vue&type=style&index=0&id=566f6e78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f6e78",
  null
  
)

export default component.exports